export class documentMaster {
  documentId: string;
  title: string;
  topic: number;
  doctype: number;
  type: number;
  totalRecords: string;
  encrydocumentId: number;
}
